<template>
  <div class="decorate-container">
    <!-- 透明度暂时不需要，可能后续会加上 -->
    <!--<div class="left">-->
    <!--  <div class="decorate-style-setting" v-if="data">-->
    <!--    <style-setting :data="data" :collapses="data.styleList" @recoverSetting="recoverSetting"></style-setting>-->
    <!--  </div>-->
    <!--  <div class="operation">-->
    <!--    <el-button type="primary" @click="save">确定</el-button>-->
    <!--    <el-button @click="closeDialog">关闭</el-button>-->
    <!--  </div>-->
    <!--</div>-->
    <div class="right">
      <div class="img-content" v-for="url in decorateList" :key="url"
           @click="selectDecorate(url)"
           :style="`background-image: url('${url}')`">
        <div class="img-model"></div>
        <span class="el-icon-success" v-show="data.decorateUrl === url"></span>
      </div>
    </div>
    <div class="operation">
      <el-button type="primary" @click="save">确定</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </div>
</template>

<script>
import styleSetting from './style-setting/style-setting'
export default {
  name: 'decorate',
  props: {
    data: {
      type: Object,
      required: true
    },
    getStyleSetting: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      decorateList: [
        require('./assets/images/decorate-1.png'),
        require('./assets/images/decorate-2.png'),
        require('./assets/images/decorate-3.png'),
        require('./assets/images/decorate-4.png')
      ]
    }
  },
  components: {styleSetting},
  methods: {
    save () {
      this.$emit('addControls', this.data, true)
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    selectDecorate (url) {
      this.data.decorateUrl = url
    },
    // 恢复默认设置
    recoverSetting () {
      let defaultStyle = this.getStyleSetting(this.data.type)
      defaultStyle && this.$_.assign(this.data, defaultStyle)
    }
  }
}
</script>

<style lang="scss">
  .decorate-container {
    /*display: flex;*/
    /*justify-content: space-between;*/
    height: 100%;
    width: 100%;
    & > .left {
      width: 230px;
      border-right: 1px solid #DCDCDC;
      height: 100%;
      padding: 9px 9px 13px 8px;
      .decorate-style-setting {
        height: calc(100% - 50px);
      }
    }
    & > .right {
      width: 100%;
      height: calc(100% - 70px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 10px 28px 0 15px;
      overflow: auto;
      .img-content {
        width: 340px;
        height: 210px;
        line-height: 248px;
        text-align: center;
        border-radius: 2px;
        position: relative;
        cursor: pointer;
        margin-bottom: 20px;
        background-color: #000;
        background-position: center;
        background-repeat: no-repeat;
        & > span {
          position: absolute;
          right: 5px;
          bottom: 7px;
          font-size: 26px;
          color: #459FFB;
        }
        .img-model {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #000;
          opacity: .5;
        }
      }
    }
    .operation {
      text-align: center;
      padding-top: 16px;
      .el-button {
        width: 78px;
        height: 26px;
        border-radius: 3px;
        padding: 0;
      }
      .el-button + .el-button {
        margin-left: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/decorate.vue